import { __ } from '@wordpress/i18n';
import { LikesIcon } from "../../../../Utils/icons";
// perf(SMASH-1836): import the submodule, not the a11y barrel — the barrel
// drags the admin-only Radix stack (accordion/tabs) into the public feed bundle.
import { VisuallyHidden } from '../../../../a11y/VisuallyHidden';

// a11y(SMASH-1377 F6): the heart icon's meaning was visual-only — SR users
// heard a bare number (WCAG 1.1.1). Append SR-only text naming the metric.
const Likes = ({ post, fillColor }) => {
    return (
        <span className='sb-post-item-meta-likes'>
            <LikesIcon fillColor={fillColor} />
            {post?.like_count}
            <VisuallyHidden>{__('likes', 'sb-customizer')}</VisuallyHidden>
        </span>
    );
}

export default Likes;
